<template>
  <GenericStep v-bind="$attrs">
    <div class="fill-height d-flex">
      <v-card
        class="col pa-0 mr-4 d-flex flex-column"
        outlined
      >
        <v-toolbar
          class="shrink"
          color="grey lighten-3"
          flat
          rounded="b-0"
        >
          <v-toolbar-title>
            Available Legal Cases
          </v-toolbar-title>

          <v-spacer />

          <v-text-field
            v-model="searchTerm"
            hide-details
            placeholder="Search terms"
            prepend-icon="mdi-magnify"
          />
        </v-toolbar>

        <v-divider />

        <div
          class="grow"
          style="position: relative;"
        >
          <div
            class="overflow-auto"
            style="position: absolute; inset: 0;"
          >
            <v-list
              class="pa-0"
              color="transparent"
              two-line
            >
              <v-hover
                v-for="(legalCaseType, index) of availableLegalCaseTypes"
                :key="legalCaseType.value"
              >
                <template #default="{ hover }">
                  <div>
                    <v-divider
                      v-if="index"
                    />
                    <v-list-item
                      @click="_ => selectLegalCaseType(legalCaseType.value)"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ legalCaseType.text }}
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action
                        class="rounded-circle pa-2 secondary lighten-3"
                        :class="{ 'd-block': hover, 'd-none': !hover }"
                      >
                        <v-icon dark>
                          mdi-chevron-right
                        </v-icon>
                      </v-list-item-action>
                    </v-list-item>
                  </div>
                </template>
              </v-hover>
            </v-list>
          </div>
        </div>
      </v-card>

      <v-card
        class="col pa-0 mr-4 d-flex flex-column"
        outlined
      >
        <v-toolbar
          class="shrink"
          color="primary"
          flat
          rounded="b-0"
        >
          <v-toolbar-title>
            Selected Legal Cases
          </v-toolbar-title>
        </v-toolbar>

        <v-divider />

        <div
          class="grow"
          style="position: relative;"
        >
          <div
            class="overflow-auto"
            style="position: absolute; inset: 0;"
          >
            <v-list
              class="pa-0"
              color="transparent"
              two-line
            >
              <v-hover
                v-for="(legalCaseType, index) of selectedLegalCaseTypes"
                :key="legalCaseType.value"
              >
                <template #default="{ hover }">
                  <div>
                    <v-divider
                      v-if="index"
                    />
                    <v-list-item
                      @click="_ => unselectLegalCaseType(legalCaseType.value)"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ legalCaseType.text }}
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action
                        class="rounded-circle pa-2 error lighten-2"
                        :class="{ 'd-block': hover, 'd-none': !hover }"
                      >
                        <v-icon dark>
                          mdi-delete-outline
                        </v-icon>
                      </v-list-item-action>
                    </v-list-item>
                  </div>
                </template>
              </v-hover>
            </v-list>
          </div>
        </div>
      </v-card>
    </div>
  </GenericStep>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { LEGAL_CASE_TYPE_NAMESPACE } from '@/store/legal-case-type'
import { QUICK_INTERVIEW_NAMESPACE } from '@/store/quick-interview'

import GenericStep from '@/components/Party/QuickInterview/GenericStep.vue'

export default {
  name: 'SuggestLegalCasesStep',

  components: {
    GenericStep,
  },

  inheritAttrs: false,

  data () {
    return {
      searchTerm: '',
      selectedLegalCaseTypeIds: [],
    }
  },

  computed: {
    availableLegalCaseTypes () {
      const term = this.searchTerm?.toLowerCase()

      return this.selectedLegalCaseTypesOptions?.reduce((res, item) => {
        if (this.selectedLegalCaseTypeIds.includes(item.value)) return res
        if (res.find(lct => lct.value === item.value)) return res
        if (term && !item.text.toLowerCase().includes(term)) return res

        res.push(item)
        return res
      }, [])
    },

    selectedLegalCaseTypes () {
      return this.selectedLegalCaseTypesOptions?.filter(lct => this.selectedLegalCaseTypeIds.includes(lct.value))
    },

    ...mapGetters(LEGAL_CASE_TYPE_NAMESPACE, [
      'selectedLegalCaseTypesOptions',
    ]),

    ...mapGetters(QUICK_INTERVIEW_NAMESPACE, [
      'quickInterview',
    ]),
  },

  watch: {
    selectedLegalCaseTypeIds (value) {
      if (value.length) {
        this.hasChanged = true
        this.$emit('changed', true)
      }
    },

    selectedLegalCaseTypes (value) {
      const step = this.quickInterview.steps_data.find(step => step.component === 'SuggestLegalCasesStep')
      if (!step?.data) return

      step.data.suggested_legal_case_types = (value || []).map(lct => lct.text)
    },
  },

  async created () {
    this.getSelectedLegalCaseTypes({ filters: [{ filter_name: 'archived', filter_value: false }] })
  },

  methods: {
    selectLegalCaseType (legalCaseTypeId) {
      this.selectedLegalCaseTypeIds.push(legalCaseTypeId)
    },

    unselectLegalCaseType (legalCaseTypeId) {
      const idx = this.selectedLegalCaseTypeIds.indexOf(legalCaseTypeId)
      if (idx < 0) return
      this.selectedLegalCaseTypeIds.splice(idx, 1)
    },

    ...mapActions(LEGAL_CASE_TYPE_NAMESPACE, [
      'getSelectedLegalCaseTypes',
    ]),
  },
}
</script>
